import { useState } from "react";
import {
  AntTextArea,
  DatePicker,
  Input as TextInput,
  UploadStepForm,
} from "components/Antd";
import { CommonButton, RippleEffect } from "components/UiElement";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { Col, Row } from "react-bootstrap";
import { dateFormateWithOutSlash, dobFormate, ext } from "helpers";
import moment from "moment";
import { validation } from "./validation";

function Step3Form({
  onSubmit,
  t,
  timelineData,
  id,
  theme,
  subscriptionData,
  loading,
}) {
  const [types, setTypes] = useState(undefined);

  let initialValues = {
    title: timelineData?.title || "",
    date: timelineData?.date || undefined,
    description: timelineData?.description || "",
    timelineImage: timelineData?.timelineImage || "",
    type: ext?.[timelineData?.timelineImage?.split(".").pop()] || undefined,
  };

  const ratios = {
    theme01: 2,
    theme02: 0.94,
    theme03: 1.76,
    theme04: 1.74,
  };

  return (
    <>
      <Formik
        initialValues={{
          ...initialValues,
        }}
        onSubmit={(val) => {
          let data = { ...val };
          if (val.date) {
            const parsedDate = moment(val.date, dobFormate); // Parse the date
            if (parsedDate.isValid()) {
              data.date = parsedDate.format(dateFormateWithOutSlash); // Format
            }
          }

          delete data.type;
          onSubmit(data);
        }}
        enableReinitialize
        validationSchema={validation(types)}
      >
        {(props) => {
          setTypes(props.values.type);
          return (
            <div className="commonCard bg-white">
              <Form>
                <div className="commonCard_head">
                  <h2 className="mb-0">
                    <span>03</span>
                    {timelineData
                      ? t("text.common.update")
                      : t("text.common.create")}{" "}
                    Timeline
                  </h2>
                </div>
                <Row>
                  <Col xs={12}>
                    <div className="form-group">
                      <label className="form-label">
                        {t("text.createMemories.timelineTitle")}
                      </label>
                      <TextInput
                        className="form-control"
                        placeholder={t("text.createMemories.enterTitle")}
                        name="title"
                        setFieldValue={props.handleChange}
                        maxLength={50}
                      />
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div className="form-group">
                      <label className="form-label">
                        {t("text.createMemories.date")}
                        <span className="form-label-date">[MM-DD-YYYY]</span>
                      </label>
                      <DatePicker
                        className="form-control"
                        placeholder="Enter Date"
                        suffixIcon={<em className="icon-calendar" />}
                        onSelectChange={(e) => {
                          props.setFieldValue("date", e);
                        }}
                        name="date"
                        validation
                        defaultValue={
                          timelineData?.date === null ||
                          timelineData?.date === undefined
                            ? undefined
                            : dayjs(timelineData?.date)
                        }
                        disabledDate={(current) => {
                          return current && current > dayjs().endOf("day");
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="uploadMultiSec">
                      <UploadStepForm
                        form={3}
                        data={timelineData}
                        aspect={ratios?.[theme]}
                        props={props}
                        subscriptionData={subscriptionData}
                        timelineData={timelineData}
                      />
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form-group">
                      <label className="form-label">
                        {t("text.createMemories.description")}
                      </label>
                      <AntTextArea
                        placeholder={t("text.createMemories.typeHere")}
                        name="description"
                        className="form-control textareaCustom step2Text"
                        style={{ resize: "none" }}
                        maxLength={250}
                        setFieldValue={props.handleChange}
                      />
                    </div>
                  </Col>

                  <Col className="mt-md-4 mt-3 text-end">
                    <RippleEffect>
                      <CommonButton
                        className="ms-auto"
                        variant="danger"
                        type="submit"
                        loading={loading}
                      >
                        {id ? "Update" : t("text.common.submit")}
                      </CommonButton>
                    </RippleEffect>
                  </Col>
                </Row>
              </Form>
            </div>
          );
        }}
      </Formik>
    </>
  );
}

export default Step3Form;
